// @core/api/endpoints/workflow/list_executions_by_actor.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListExecutionsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List visible executions by effective actor
 * Returns a paginated list of executions by actor. Supports filtering and sorting.
 */
export async function ListExecutionsByActor(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListExecutionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/executions`;
  const requestOptions = options;
  return client.get<ListExecutionsResponse>(requestPath, { ...requestOptions, params });
}
